export default __webpack_public_path__ + "static/media/WNo.8-12.c7f181e0.jpg";